import { render, staticRenderFns } from "./DeliveryOrder.vue?vue&type=template&id=58a36751&scoped=true"
import script from "./DeliveryOrder.vue?vue&type=script&lang=js"
export * from "./DeliveryOrder.vue?vue&type=script&lang=js"
import style0 from "./DeliveryOrder.vue?vue&type=style&index=0&id=58a36751&prod&scoped=true&lang=css"
import style1 from "./DeliveryOrder.vue?vue&type=style&index=1&id=58a36751&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a36751",
  null
  
)

export default component.exports